import { format, isValid } from 'date-fns';
import { parseLocalDate } from '@/services/utils';

function parsed(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return isValid(date) ? date : null;
}

/** When a check ran, in the reader's local time — the line a printed sheet is filed by. */
export function formatRunAt(iso: string | null | undefined): string {
  const date = parsed(iso);
  return date ? format(date, "MMM d, yyyy 'at' h:mm a") : '';
}

export function formatRunDate(iso: string | null | undefined): string {
  const date = parsed(iso);
  return date ? format(date, 'MMM d, yyyy') : '';
}

/** A yyyy-MM-dd for the API's date filter, from what LlDatePicker hands back. */
export function toApiDate(
  value: Date | string | null | undefined,
): string | null {
  if (!value) return null;
  // A bare yyyy-MM-dd must stay the local date, not UTC midnight.
  const date = value instanceof Date ? value : parseLocalDate(value);
  return date && isValid(date) ? format(date, 'yyyy-MM-dd') : null;
}
